import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, ArrowRight } from 'lucide-react';

interface ServiceStickyBarProps {
  text?: string;
  buttonLabel?: string;
}

const ServiceStickyBar = ({ text, buttonLabel }: ServiceStickyBarProps) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 500);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-40 bg-petrol/95 backdrop-blur-sm border-t border-petrol-foreground/10 py-3 px-6 transition-all animate-in slide-in-from-bottom duration-300">
      <div className="max-w-5xl mx-auto flex items-center justify-between gap-4">
        <div className="flex items-center gap-4 min-w-0">
          <Link
            to="/services"
            onClick={() => window.scrollTo(0, 0)}
            className="inline-flex items-center gap-1.5 text-petrol-foreground/80 hover:text-primary text-xs sm:text-sm font-heading font-medium transition-colors shrink-0"
          >
            <ArrowLeft size={14} /> <span className="hidden sm:inline">Tous nos services</span><span className="sm:hidden">Services</span>
          </Link>
          <p className="text-petrol-foreground/70 text-sm font-heading hidden md:block truncate">
            {text || 'Découvrez nos prestations et obtenez un devis personnalisé.'}
          </p>
        </div>
        <Link
          to="/contact"
          onClick={() => window.scrollTo(0, 0)}
          className="inline-flex items-center gap-2 px-6 py-2.5 rounded-full bg-primary text-primary-foreground font-heading font-medium text-sm hover:bg-primary/90 transition-colors shrink-0"
        >
          {buttonLabel || 'Prendre rendez-vous'} <ArrowRight size={14} />
        </Link>
      </div>
    </div>
  );
};

export default ServiceStickyBar;
